// Tracking "received", provider success and local isEnded are not completion.
// Resolve authenticates the owner and restaurant of this exact checkout.
export const completedCheckoutOrder = (
  resolution,
  checkoutId,
  completionReply = false
) => {
  if (
    !checkoutId ||
    resolution?.checkout_id !== checkoutId ||
    !(
      resolution.already_confirmed ||
      resolution.state === 'already_confirmed' ||
      (completionReply &&
        !resolution.state &&
        (resolution.success === true || resolution.status === 'completed'))
    ) ||
    (resolution.state && resolution.state !== 'already_confirmed') ||
    resolution.operation_pending ||
    !(
      resolution.order?.order_id ||
      resolution.order?.id ||
      (completionReply && resolution.status === 'completed' && resolution.id)
    )
  )
    return null;
  return resolution.order || resolution;
};

export const canResumeCheckout = (resolution, checkoutId) =>
  resolution?.checkout_id === checkoutId &&
  Object.prototype.hasOwnProperty.call(resolution, 'delivery_revision') &&
  resolution.resume_allowed === true &&
  resolution.resume_action === 'retry_create_payment_intent' &&
  ['unpaid', 'action_required'].includes(resolution.state) &&
  !resolution.operation_pending &&
  !resolution.already_confirmed;

// A retained quote owns its time just as it owns its amount and destination.
// Older snapshots may lack the window; still check the selected time rather
// than letting known-payment resumption bypass expiry altogether.
export const issuedCheckoutTimeExpired = (
  checkout,
  selectedTime,
  now = Date.now()
) => {
  const end = Number(checkout?.saved_cart?.end || selectedTime?.value?.end);
  return Number.isFinite(end) && end > 0 && end <= now / 1000;
};

export const checkoutRecoveryStatus = (resolution) => {
  if (resolution?.operation_pending)
    return 'A checkout operation is still processing. Check its status; do not pay again.';
  if (['processing', 'requires_capture'].includes(resolution?.state))
    return 'Your payment is processing. Do not pay again. Check its status for an update.';
  if (resolution?.state === 'succeeded')
    return 'Payment was accepted. The order is still being finalized. Do not pay again.';
  if (resolution?.state === 'unavailable')
    return 'Payment status is unavailable. Your existing checkout is kept. Recovery is required before paying again.';
  if (resolution?.resume_allowed === false)
    return 'This checkout cannot resume payment yet. Review its status or refresh the original quote when offered.';
  if (['unpaid', 'action_required'].includes(resolution?.state))
    return 'Payment is unfinished. Review the original order before resuming payment.';
  return 'Order completion is not confirmed. Check the existing checkout status before paying again.';
};
